export default __webpack_public_path__ + "static/media/whatsappPrimary.aa3c6b88.svg";